/**
 * @generated SignedSource<<100366de2ab5e1c3a32e55639f6f6d6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef$data = {
  readonly isWebSearchEnabled: boolean | null;
  readonly isWebSearchEnabledForOrganization: boolean | null;
  readonly " $fragmentType": "webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef";
};
export type webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef$key = {
  readonly " $data"?: webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillDataComponent_scenarioRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isWebSearchEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "isWebSearchEnabledForOrganization"
    }
  ],
  "type": "AgentStudioBaseConfiguration",
  "abstractKey": "__isAgentStudioBaseConfiguration"
};

(node as any).hash = "eb667dbf1dc8978308bca803a75d2549";

export default node;
